import type { CSSProperties } from 'react';
import { CARD_RADIUS } from './chatteaser3.constants';

// Mobile re-scales the card's left column (avatar/logo + paddings + role tag) via
// the `--ct3-*` custom properties that chatteaser3.styles.ts reads. Desktop omits
// them and falls back to its full-size defaults, so it renders unchanged.
type CssVars = Record<`--${string}`, string>;

const MOBILE_CARD_VARS: CssVars = {
  '--ct3-pad-x': '24px',
  '--ct3-avatar-w': '46px',
  '--ct3-avatar-icon': '24px',
  '--ct3-avatar-pad-y': '11px',
  '--ct3-row-gap': '12px',
  '--ct3-title-indent': '58px',
  '--ct3-role-shift': '44px',
  '--ct3-role-pad-l': '58px',
  '--ct3-role-minw': '180px',
};

// Mobile layout: the page provides outer padding; the card stack fills the
// padded stage above the bottom tab bar.
export const MOBILE_WRAPPER_STYLE: CSSProperties = {
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  borderRadius: CARD_RADIUS,
  touchAction: 'pan-y',
  ...MOBILE_CARD_VARS,
};

export const MOBILE_TABBAR_STYLE: CSSProperties = {
  position: 'absolute',
  bottom: 22,
  left: 0,
  right: 0,
  height: 100,
  overflow: 'hidden',
  touchAction: 'pan-y',
};
